import { instance as axios } from './axiosInstance';

const END_POINT = "/api/administrador/data"

const getHeader = (token) => (
  {
    'Authorization': `Bearer ${token}`
  }
);


export const getTourRequirements = (token) => {
  const headers = getHeader(token)
  return axios.get(END_POINT, { headers });
};


export const checkTourRequirements = (ppp) => {
  alert('chegamos aqui');
  return ppp;
}